import React from 'react'
import { Box, Button, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material'
import { columnDefsOne } from '../constants'
import EditIcon from '@mui/icons-material/Edit'
import { QrPaymentSettlemntList } from './QRBeneficiaryConst'
import { getDQMantisTestFundTransfer } from '../../../../../../store/Acounting/acounting_action'
import { useDispatch } from 'react-redux'

const QRTable = (props) => {
    const { tableData, tableHeader, QRInfo } = props
    const dispatch = useDispatch()
    const { QRBeneficiaryValue, BranchDetailsList, loginData, setQRBeneficiaryValue, setQRbranch, setQRPayment, setMsg, setIsSuccess } = QRInfo
    const handleEditBtn = (val) => {
        setQRBeneficiaryValue((prev) => ({
            ...prev,
            IsActive: val.IsActive,
            AccountName: val?.AccountName,
            AccountNumber: val?.AccountNumber,
            IFSCCode: val?.IFSCCode,
            BankName: val?.BankName,
            MobileNo: val?.MobileNo,
            EmailID: val?.EmailID,
            SettlementDays: val?.SettlementDays,
            TransactionFeePer: val?.TransactionFeePer,
            BranchID: val?.BranchID,
            InsertUpdate: 'Update',
            BeneficiaryAccountDetailsID: val?.BeneficiaryAccountDetailsID,
            PaymentProductTypeId: val?.PaymentProductTypeId
        }))
        if (val.BranchID === 0) {
            setQRPayment(QrPaymentSettlemntList?.[0])
        } else {
            setQRPayment(QrPaymentSettlemntList?.[1])
            let branch = BranchDetailsList?.filter((item) => item.BranchID === val.BranchID)
            setQRbranch(branch)
        }
    }
    const handleTestTransfer = (val) => {
        let body = {
            intUserID: loginData?.intUserID,
            intCompanyID: loginData?.intCompanyID,
            BeneficiaryAccountDetailsID: val
        }
        dispatch(getDQMantisTestFundTransfer(body))
        .then((res) => {
                setMsg('Test Transfer Initiated')
                setIsSuccess(true)
        })
        .catch((err) => console.error(err))
    }
    return (
      <>
        <TableContainer className="scrollBlue" component={Paper} style={{ marginBottom: '10px', maxHeight: '45vh', overflowX: 'auto' }}>
          <Table
            stickyHeader
            size="small"
            aria-label="a dense table"
            sx={{
              '&.MuiTableCell-root': {
                padding: '6px 8px!important',
                // marginBottom:'10px !important'
              },
            }}
          >
            <TableHead style={{ position: `sticky`, top: `0`, zIndex: 2 }}>
              <TableRow>
                <TableCell
                  key={`tbl-header-${tableHeader}`}
                  colSpan={columnDefsOne?.length}
                  sx={{
                    backgroundColor: '#DAEDFE',
                    fontSize: '12px',
                    fontWeight: '600',
                    color: '#444',
                    height: '36px',
                    whiteSpace: 'pre',
                    padding: '6px',
                  }}
                >
                  {tableHeader}
                </TableCell>
              </TableRow>
              <TableRow>
                {columnDefsOne?.map((col, index) => (
                  <TableCell
                    key={`CityHeader-${index}`}
                    sx={{
                      ...col.headerSx,
                      backgroundColor: '#DAEDFE',
                      fontSize: '12px',
                      fontWeight: '600',
                      color: '#444',
                      height: '36px',
                      whiteSpace: 'pre',
                      padding: '6px',
                    }}
                  >
                    {col.headerName}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            {tableData?.length > 0 ? (
              <TableBody>
                {tableData.map((val, index) => (
                  <TableRow>
                    <TableCell
                      sx={{
                        height: '40px',
                        fontSize: '12px',
                        fontWeight: '500',
                        color: '#444',
                        padding: '6px',
                        color: val?.IsActive === '1' ? '#155A03' : '#FF0000',
                      }}
                    >
                      {val?.ProviderName}
                    </TableCell>
                    <TableCell
                      sx={{
                        height: '40px',
                        fontSize: '12px',
                        fontWeight: '500',
                        color: '#444',
                        padding: '6px',
                        color: val?.IsActive === '1' ? '#155A03' : '#FF0000',
                      }}
                    >
                      {val?.BusinessVerticalName}
                    </TableCell>
                    <TableCell
                      sx={{
                        height: '40px',
                        fontSize: '12px',
                        fontWeight: '500',
                        color: '#444',
                        padding: '6px',
                        color: val?.IsActive === '1' ? '#155A03' : '#FF0000',
                      }}
                    >
                      {val?.CompanyBranch}
                    </TableCell>
                    <TableCell
                      sx={{
                        height: '40px',
                        fontSize: '12px',
                        fontWeight: '500',
                        color: '#444',
                        padding: '6px',
                        color: val?.IsActive === '1' ? '#155A03' : '#FF0000',
                      }}
                    >
                      {val?.AccountName}
                    </TableCell>
                    <TableCell
                      sx={{
                        height: '40px',
                        fontSize: '12px',
                        fontWeight: '500',
                        color: '#444',
                        padding: '6px',
                        color: val?.IsActive === '1' ? '#155A03' : '#FF0000',
                      }}
                    >
                      {val?.AccountNumber}
                    </TableCell>
                    <TableCell
                      sx={{
                        height: '40px',
                        fontSize: '12px',
                        width: '12%',
                        fontWeight: '500',
                        color: '#444',
                        padding: '6px',
                        color: val?.IsActive === '1' ? '#155A03' : '#FF0000',
                      }}
                    >
                      {val?.BankName}
                    </TableCell>
                    <TableCell
                      sx={{
                        height: '40px',
                        fontSize: '12px',
                        fontWeight: '500',
                        color: '#444',
                        padding: '6px',
                        color: val?.IsActive === '1' ? '#155A03' : '#FF0000',
                      }}
                    >
                      {val?.IFSCCode}
                    </TableCell>
                    <TableCell
                      sx={{
                        height: '40px',
                        fontSize: '12px',
                        width: '12%',
                        fontWeight: '500',
                        color: '#444',
                        padding: '6px',
                        color: val?.IsActive === '1' ? '#155A03' : '#FF0000',
                      }}
                    >
                      {val?.Status}
                    </TableCell>
                    <TableCell
                      sx={{
                        height: '40px',
                        fontSize: '12px',
                        fontWeight: '500',
                        color: '#444',
                        padding: '6px',
                        color: val?.IsActive === '1' ? '#155A03' : '#FF0000',
                      }}
                    >
                      {val.Action === 'Edit' && (
                        <span
                          id={`editBtn-${index}`}
                          tabIndex={0}
                          style={{
                            display: 'flex',
                            color: '#007bfd',
                            fontSize: '13px',
                            fontWeight: 'bold',
                            width: '52px',
                            padding: '2px 4px',
                            marginLeft: '-6px',
                          }}
                          onClick={() => handleEditBtn(val)}
                        >
                          <EditIcon sx={{ marginRight: '3px' }} />
                          Edit
                        </span>
                      )}
                      {val?.Action == 'Test Transfer' && (
                        <Button
                          variant="contained"
                          // onKeyDown={(e) => navigation3(e, 'printBtn', 'gv-partyName', () => { })}
                          id={'load_Btn'}
                          sx={{ width: '100%', padding: '1px 0px !important', fontSize: '14px !important' }}
                          className="btn btn-primary"
                          onClick={() => {
                            handleTestTransfer(val.BeneficiaryAccountDetailsID)
                          }}
                        >
                          Test Transfer
                        </Button>
                      )}
                    </TableCell>
                    <TableCell
                      sx={{
                        height: '40px',
                        fontSize: '12px',
                        fontWeight: '500',
                        color: '#444',
                        padding: '6px',
                        color: val?.IsActive === '1' ? '#155A03' : '#FF0000',
                      }}
                    >
                      {val?.username}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            ) : (
              <TableBody>
                <TableRow>
                  <TableCell colSpan={columnDefsOne?.length}>
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                        marginTop: '20px',
                        marginBottom: '20px',
                        color: 'red',
                        fontSize: '14px',
                      }}
                    >
                      <span>No Results Found For The Selected Filters.</span>
                    </div>
                  </TableCell>
                </TableRow>
              </TableBody>
            )}
          </Table>
        </TableContainer>
      </>
    )
}

export default QRTable
